module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"opacity":"Opacité","time":"Sélection temporelle","legend-label":"Légende","opacity-label":"Opacité","delete-label":"Supprimer","layer-list-label":"Liste des couches","show-hide-label":"Afficher / masquer","group-filter":"Filtre par zone d\u0027intérêt","group-filter-all":"Tout afficher","group-filter-selected":"Filtre:","options":"Options"},"de":{}}')
  delete Component.options._Ctor
}
